import { JobTitle } from '@accredible-frontend-v2/models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CareerPreference, CareerPreferenceUpdatePayload } from '../entities/set-your-goal.model';
import { LerApiService } from './ler-api.service';

@Injectable({ providedIn: 'root' })
export class CareerPreferenceApiService extends LerApiService {
  private readonly endpoint = '/v1/ler/career_preference';

  getCareerPreference(): Observable<CareerPreference> {
    return this._get(this.endpoint).pipe(
      map((res) => this._handleResponse(res, 'career_preference')),
      catchError((res) => this._handleError(res)),
    );
  }

  updateCareerPreference(payload: CareerPreferenceUpdatePayload): Observable<CareerPreference> {
    return this._patch(this.endpoint, payload).pipe(
      map((res) => this._handleResponse(res, 'career_preference')),
      catchError((res) => this._handleError(res)),
    );
  }

  searchJobTitles(query: string): Observable<JobTitle[]> {
    const url = `/v1/internal/job_insights/job_titles?query=${encodeURIComponent(query)}`;
    return this._get(url).pipe(
      map((res) => this._handleResponse(res, 'job_titles')),
      catchError((res) => this._handleError(res)),
    );
  }
}
